export interface IDropdown {
  label: string;
  value: string;
}

export interface AbleExpiryPasswordSettings{
  firstLoginDataPeople?: Date;
  controlPasswordExpired?: boolean ;
  passwordExpiry?: boolean ;
  passwordDaysExpire?: number;
  checkFirstLogin?: boolean;
  hasExpired?: boolean
  currentLoginDate?: Date
}
